import { createSlice } from '@reduxjs/toolkit';
import {
  fetchContacts,
  addContact,
  removeContact,
  editContact,
} from './operations';

const handlePending = state => {
  state.contacts.isLoading = true;
};
const handleRejected = (state, action) => {
  state.contacts.isLoading = false;
  state.contacts.error = action.payload;
};

export const contactsSlice = createSlice({
  name: 'contacts',
  initialState: {
    contacts: {
      items: [],
      isLoading: false,
      error: null,
    },
    filter: '',
  },
  reducers: {
    writeFilter(state, action) {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [fetchContacts.pending]: handlePending,
    [fetchContacts.fulfilled](state, action) {
      state.contacts.isLoading = false;
      state.contacts.error = null;
      state.contacts.items = action.payload;
    },
    [fetchContacts.rejected]: handleRejected,

    [addContact.pending]: handlePending,
    [addContact.fulfilled](state, action) {
      state.contacts.items.push(action.payload);
      state.contacts.isLoading = false;
      state.contacts.error = null;
    },
    [addContact.rejected]: handleRejected,

    [removeContact.pending]: handlePending,
    [removeContact.fulfilled](state, action) {
      const index = state.contacts.items.findIndex(
        el => el.id === action.payload.id
      );
      state.contacts.items.splice(index, 1);
      state.contacts.isLoading = false;
      state.contacts.error = null;
    },
    [removeContact.rejected]: handleRejected,

    [editContact.pending]: handlePending,
    [editContact.fulfilled](state, action) {
      const index = state.contacts.items.findIndex(
        el => el.id === action.payload.id
      );
      state.contacts.items.splice(index, 1, action.payload);
      state.contacts.isLoading = false;
      state.contacts.error = null;
    },
    [editContact.rejected]: handleRejected,
  },
});

export const { writeFilter } = contactsSlice.actions;
